module.exports = __webpack_public_path__ + "static/media/ao.2bfdbcc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ao.svg
// module id = 49
// module chunks = 0